// extracted by mini-css-extract-plugin
module.exports = {"policy":"policy_policy__TNqyi"};